module.exports = __webpack_public_path__ + "img/LiSA-logo.6320f251.svg";